import { render, staticRenderFns } from "./deleteBtn.vue?vue&type=template&id=51001dcb&"
import script from "./deleteBtn.vue?vue&type=script&lang=js&"
export * from "./deleteBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports